/**
 * TextBlock categories.
 * @hidden
 */
export class TextBlockCategory {
    public static userGridConfig = "usergridconfig";
    public static global = "global";
    public static userData = "userdata";
}
